(() => {
  const SELECTORS = {
    container: '[data-grip-fitting]',
    required: '[data-grip-fitting-required]',
    fittingQuantityContainer:
      '[data-grip-fitting-quantity-container]',
    fittingQuantity: '[data-grip-fitting-quantity]',
    message: '[data-grip-fitting-message]',
    productForm: 'form[action*="/cart/add"]',
    productQuantity: '[name="quantity"]',
    submitButton: '[type="submit"]'
  };

  function getCartRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function createReference() {
    if (
      typeof crypto !== 'undefined' &&
      typeof crypto.randomUUID === 'function'
    ) {
      return crypto.randomUUID();
    }

    return [
      Date.now().toString(36),
      Math.random().toString(36).slice(2)
    ].join('-');
  }

  function parsePositiveInteger(value, fallback = 1) {
    const parsed = Number.parseInt(value, 10);

    return Number.isFinite(parsed) && parsed > 0
      ? parsed
      : fallback;
  }

  function getProductQuantity() {
    const inputs = document.getElementsByName('quantity');
    if (inputs == null || inputs[0] == null) {
      return 1;
    }
    return parsePositiveInteger(inputs[0].value, 1);
  }

  function getMainVariantId(form) {
    const input = form.querySelector('[name="id"]');
    const variantId = Number.parseInt(input?.value || '', 10);

    if (!Number.isFinite(variantId) || variantId <= 0) {
      throw new Error('The selected grip variant could not be found.');
    }

    return variantId;
  }

  function getFittingVariantId(container) {
    const variantId = Number.parseInt(
      container.dataset.fittingVariantId || '',
      10
    );

    if (!Number.isFinite(variantId) || variantId <= 0) {
      throw new Error('The grip-fitting service has not been configured.');
    }

    return variantId;
  }

  function getProperties(form) {
    const properties = {};

    form
      .querySelectorAll('[name^="properties["]:not([disabled])')
      .forEach((field) => {
        if (
          (field.type === 'checkbox' ||
            field.type === 'radio') &&
          !field.checked
        ) {
          return;
        }

        const match = field.name.match(/^properties\[(.+)]$/);

        if (!match || field.value === '') {
          return;
        }

        properties[match[1]] = field.value;
      });

    return properties;
  }

  function fittingIsRequired(container) {
    const select = container.querySelector(
      SELECTORS.required
    );

    return select?.value === 'Yes';
  }

  function synchroniseFittingQuantity(container) {
    const form = container.closest(
      SELECTORS.productForm
    );

    const quantityContainer = container.querySelector(
      SELECTORS.fittingQuantityContainer
    );

    const fittingQuantityInput = container.querySelector(
      SELECTORS.fittingQuantity
    );

    const message = container.querySelector(
      SELECTORS.message
    );

    if (
      !form ||
      !quantityContainer ||
      !fittingQuantityInput ||
      !message
    ) {
      return;
    }

    const productQuantity = getProductQuantity();
    const isRequired = fittingIsRequired(container);

    quantityContainer.hidden = !isRequired;

    if (!isRequired) {
      message.textContent = '';
      return;
    }

    fittingQuantityInput.max = String(productQuantity);

    let fittingQuantity = parsePositiveInteger(
      fittingQuantityInput.value,
      1
    );

    if (fittingQuantity > productQuantity) {
      fittingQuantity = productQuantity;
      fittingQuantityInput.value =
        String(productQuantity);
    }

    const total = fittingQuantity * 3;

    message.textContent =
      `${fittingQuantity} ` +
      `${fittingQuantity === 1 ? 'grip' : 'grips'} ` +
      `fitted for £${total.toFixed(2)}.`;
  }

  function validateFittingQuantity(container) {
    const form = container.closest(
      SELECTORS.productForm
    );

    const input = container.querySelector(
      SELECTORS.fittingQuantity
    );

    if (!form || !input || !fittingIsRequired(container)) {
      return 0;
    }

    const productQuantity = getProductQuantity();
    const fittingQuantity = Number.parseInt(input.value,10);

    if (
      !Number.isFinite(fittingQuantity) ||
      fittingQuantity < 1
    ) {
      throw new Error(
        'Enter how many grips you would like us to fit.'
      );
    }

    if (fittingQuantity > productQuantity) {
      throw new Error(
        `You can only request fitting for up to ` +
        `${productQuantity} ` +
        `${productQuantity === 1 ? 'grip' : 'grips'}.`
      );
    }

    return fittingQuantity;
  }

  async function addItems(items) {
    const response = await fetch(
      `${getCartRoot()}cart/add.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items })
      }
    );

    let result = null;

    try {
      result = await response.json();
    } catch {
      result = null;
    }

    if (!response.ok) {
      throw new Error(
        result?.description ||
        result?.message ||
        'The grips could not be added to the basket.'
      );
    }

    return result;
  }

  function setSubmitting(form, isSubmitting) {
    const button = form.querySelector(
      SELECTORS.submitButton
    );

    if (!button) {
      return;
    }

    button.disabled = isSubmitting;
    button.setAttribute(
      'aria-busy',
      String(isSubmitting)
    );

    if (isSubmitting) {
      if (!button.dataset.originalText) {
        button.dataset.originalText =
          button.textContent.trim();
      }

      button.textContent = 'Adding…';
      return;
    }

    if (button.dataset.originalText) {
      button.textContent =
        button.dataset.originalText;

      delete button.dataset.originalText;
    }
  }

  function isMaximumQuantityError(message) {
    const normalised = message.toLowerCase();

    return (
      normalised.includes('maximum quantity') ||
      normalised.includes('already in your cart') ||
      normalised.includes('already in your basket')
    );
  }

  function initialiseContainer(container) {
    synchroniseFittingQuantity(container);
  }

  function initialise(root = document) {
    root
      .querySelectorAll(SELECTORS.container)
      .forEach(initialiseContainer);
  }

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const container = event.target.closest(
      SELECTORS.container
    );

    if (container) {
      synchroniseFittingQuantity(container);
      return;
    }

    if (event.target.matches(SELECTORS.productQuantity)) {
      const form = event.target.closest(
        SELECTORS.productForm
      );

      form
        ?.querySelectorAll(SELECTORS.container)
        .forEach(synchroniseFittingQuantity);
    }
  });

  document.addEventListener('input', (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    if (
      event.target.matches(SELECTORS.fittingQuantity) ||
      event.target.matches(SELECTORS.productQuantity)
    ) {
      const form = event.target.closest(
        SELECTORS.productForm
      );

      form
        ?.querySelectorAll(SELECTORS.container)
        .forEach(synchroniseFittingQuantity);
    }
  });

  document.addEventListener(
    'submit',
    async (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const form = event.target.closest(
        SELECTORS.productForm
      );

      if (!form) {
        return;
      }

      const container = form.querySelector(
        SELECTORS.container
      );

      if (!container) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        const productQuantity =
          getProductQuantity(form);

        const mainVariantId =
          getMainVariantId(form);

        const isRequired =
          fittingIsRequired(container);

        const fittingQuantity =
          validateFittingQuantity(container);

        const reference =
          createReference();

        const productProperties = {
          ...getProperties(form),
          'Grip fitting':
            isRequired
              ? `${fittingQuantity} ${
                  fittingQuantity === 1
                    ? 'grip'
                    : 'grips'
                }`
              : 'No'
        };

        if (isRequired) {
          productProperties._grip_fitting_reference =
            reference;

          productProperties._grip_fitting_quantity =
            String(fittingQuantity);
        }

        const items = [
          {
            id: mainVariantId,
            quantity: productQuantity,
            properties: productProperties
          }
        ];

        if (isRequired) {
          const fittingVariantId =
            getFittingVariantId(container);

          items.push({
            id: fittingVariantId,
            quantity: fittingQuantity,
            properties: {
              'Fitting for':
                `${fittingQuantity} ${
                  fittingQuantity === 1
                    ? 'grip'
                    : 'grips'
                }`,
              _grip_fitting_reference: reference,
              _fitting_for_variant:
                String(mainVariantId)
            }
          });
        }

        setSubmitting(form, true);

        await addItems(items);

        window.location.assign(
          `${getCartRoot()}cart`
        );
      } catch (error) {
        console.error(
          'Grip-fitting add-to-cart error:',
          error
        );

        const message =
          error instanceof Error
            ? error.message
            : 'The grips could not be added to the basket.';

        if (isMaximumQuantityError(message)) {
          window.alert(
            'The maximum available quantity of this grip is already in your basket. ' +
            'Please review your basket before continuing.'
          );

          window.location.assign(
            `${getCartRoot()}cart`
          );

          return;
        }

        window.alert(message);
        setSubmitting(form, false);
      }
    },
    true
  );

  initialise();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialise(event.target);
    }
  );
})();